import { useState } from 'react';

import { Alert, Box, Button, Card, Divider, IconButton, InputAdornment, Paper, Stack, TextField, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { alpha, useTheme } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LoadingButton from '@mui/lab/LoadingButton';

import { bgGradient } from '../../themes/css';
import { imgBg } from '../../assets/background/overlay.jpg';

import { useDispatch } from 'react-redux';
import { setToken, loginSuccess } from "../../redux/userSlice";
import { UserAPI } from '../../apis/UserAPI';
import { useNavigate } from 'react-router-dom';


const Container = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
});
const LoginContainer = styled(Paper)({
    width: '400px',
    padding: '8px',
});
const Title = styled(Typography)({

});

const Login = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ severity: "", errors: [] });
    const [showPassword, setShowPassword] = useState(false);
    const [loginData, setLoginData] = useState({
        userName: '',
        password: ''
    });

    const handleInputChange = (event) => {
        setLoginData({ ...loginData, [event.target.name]: event.target.value })
    }
    const handleClick = () => {
        setLoading(true);
        setError({ severity: "", errors: [] });

        UserAPI.login(loginData)
            .then((res) => {
                // console.log(res);
                dispatch(setToken(res));
                UserAPI.getLoginData()
                    .then((res) => {
                        console.log(res);
                        dispatch(loginSuccess(res));
                        setLoading(false);
                        navigate('/admin');
                    })
                    .catch((e) => {
                        setLoading(false);
                        console.log(e.response);
                    });
            })
            .catch((e) => {
                setLoading(false);
                console.log(e);
                if (e.code === "ERR_NETWORK") {
                    setError({
                        severity: "error",
                        errors: ["Falha"],
                    });
                } else {
                    if (e.response.status === 400) {
                        setError({
                            severity: "error",
                            errors: e.response.data.Errors,
                        });
                    }
                }
            });
    };

    return (
        <Box
            sx={{
                ...bgGradient({
                    color: alpha(theme.palette.background.default, 0.9),
                    imgUrl: "https://minimal-kit-react.vercel.app/assets/background/overlay_4.jpg",
                }),
                height: '100vh',
            }}
        >
            <Stack alignItems="center" justifyContent="center" sx={{ height: 1 }}>
                <Card
                    sx={{
                        p: 5,
                        width: 1,
                        maxWidth: 420,
                    }}
                >
                    <Typography variant="h4">Virtual CTRL</Typography>

                    <Box mt={4}>
                        {error.severity !== "" && (
                            <Box mb={4} sx={{ display: "block" }}>
                                <Alert severity={error.severity}>
                                    <strong>Falha no login!</strong>
                                    {error.errors.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </Alert>
                            </Box>
                        )}

                        <Stack spacing={3}>
                            <TextField
                                name="userName"
                                label="Usuário"
                                value={loginData.userName}
                                onChange={handleInputChange}
                            />

                            <TextField
                                name="password"
                                label="Senha"
                                type={showPassword ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                value={loginData.password}
                                onChange={handleInputChange}
                            />
                        </Stack>
                        <Box mt={3}>
                            <LoadingButton
                                fullWidth
                                size="large"
                                type="submit"
                                variant="contained"
                                color="success"
                                disabled={loginData.userName === '' || loginData.password === ''}
                                loading={loading}
                                onClick={handleClick}
                            >
                                Entrar
                            </LoadingButton>
                        </Box>
                    </Box>
                </Card>
            </Stack>
        </Box >
    )
}
export default Login;